import {  Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiChipOverrides = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCheckbox'];
}


function getMuiCheckboxOverride(): MuiChipOverrides {
  return {
    styleOverrides: {
      root: {
        '& .MuiSvgIcon-root': {
          fontSize: "var(--checkbox-icon-size)",
          color: "var(--checkbox-icon-clr)",
        },
        [`
         &.Mui-disabled .MuiSvgIcon-root,
         &.Mui-checked.Mui-disabled .MuiSvgIcon-root
        `]: {
          color: "var(--checkbox-icon-clr)",
        },
      },
      colorPrimary: {
        '&.Mui-checked .MuiSvgIcon-root': {
          color: "var(--checkbox-icon-clr-primary)",
        }
      },
      colorSecondary: {
        '&.Mui-checked .MuiSvgIcon-root': {
          color: "var(--checkbox-icon-clr-secondary)",
        }
      }
    }
  }
}

export default getMuiCheckboxOverride;